import {
    setFigureList,
    setGeoMarkerList,
    setHighlightObjectGeoJSON,
    setHighlightObjectStyleConfig,
} from "../../../../stateManagement/reducers";
import { store } from "../../../../stateManagement/store";
import { removeOverlayFromStateById, upsertOverlayInState } from "../../../map/mapFeatures/mapFunctions/addOverlays/overlayState";

export const SEARCH_LOCATION_OVERLAY_ID = "search-location-info";
export const SEARCH_LOCATION_MARKER_ID = "search-location-marker";
export const SEARCH_OFFSET_CONNECTOR_ID = "search-offset-connector";
export const SEARCH_HIGHLIGHT_OWNER = "search";

function filterById(list: any, id: string) {
    return Array.isArray(list) ? list.filter((item: any) => item?.id !== id) : [];
}

export function upsertSearchLocationOverlay(overlay: any) {
    upsertOverlayInState(overlay);
}

export function removeSearchLocationOverlay() {
    removeOverlayFromStateById(SEARCH_LOCATION_OVERLAY_ID);
}

function getMapGeoMarkersWithoutSearchMarker() {
    return filterById(store.getState().map.geoMarkerList ?? [], SEARCH_LOCATION_MARKER_ID);
}

export function upsertSearchGeoMarker(marker: any) {
    store.dispatch(setGeoMarkerList([...getMapGeoMarkersWithoutSearchMarker(), marker]));
}

export function removeSearchGeoMarker() {
    store.dispatch(setGeoMarkerList(getMapGeoMarkersWithoutSearchMarker()));
}

function getMapFiguresWithoutSearchConnector() {
    return filterById(store.getState().map.figureList ?? [], SEARCH_OFFSET_CONNECTOR_ID);
}

export function upsertSearchConnectorFigure(figure: any) {
    store.dispatch(setFigureList([...getMapFiguresWithoutSearchConnector(), figure]));
}

export function removeSearchConnectorFigure() {
    store.dispatch(setFigureList(getMapFiguresWithoutSearchConnector()));
}

function clearSearchHighlight() {
    const styleConfig = store.getState().map.highlightObjectStyleConfig;
    if (styleConfig?.owner !== SEARCH_HIGHLIGHT_OWNER) return;

    store.dispatch(setHighlightObjectGeoJSON(null));
    store.dispatch(setHighlightObjectStyleConfig(null));
}

export function clearSearchMapArtifacts() {
    removeSearchLocationOverlay();
    removeSearchGeoMarker();
    removeSearchConnectorFigure();
    clearSearchHighlight();
}
